import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NotificationActions } from '@next/core-lib/notification';
import { UserActions } from '@next/core-lib/user';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as AppActions from './actions';
import { RuminantsAnalysisService } from '../measurements/services/ruminants-analysis.service';
import { AppState } from '../shared/models/models';
import { ApiService } from '../shared/services/api.service';

@Injectable()
export class AppEffects {
  protected store = inject<Store<AppState>>(Store);
  protected actions$ = inject(Actions);
  protected api = inject(ApiService);
  private readonly ruminantsAnalysisApi = inject(RuminantsAnalysisService);

  locationInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.locationInitialized),
      mergeMap((_) => of(AppActions.loadRationComponentsRequest())),
    ),
  );

  loadRationComponents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.loadRationComponentsRequest),
      mergeMap(() =>
        this.ruminantsAnalysisApi
          .getRationComponents()
          .pipe(
            map((rationComponents) => AppActions.loadRationComponentsSuccess({ rationComponents })),
          ),
      ),
      catchError((error: HttpErrorResponse) =>
        of(NotificationActions.errorSnackbar({ message: error.message })),
      ),
    ),
  );
}
